<template>
  <v-menu
    lazy
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-left="40"
    max-width="290px"
    v-model="active"
    ref="datepicker">
    <v-text-field
      slot="activator"
      :label="label"
      v-model="formattedDate"
      hide-details
      readonly></v-text-field>
    <v-date-picker :allowed-dates="allowedDates" v-model="date" :first-day-of-week="firstDayOfWeek" no-title scrollable></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: Date,
    'date-format': {type: String, default: "DD.MM.YYYY"},
    'first-day-of-week': {type: String, default: "0"},
    label: String,
    'disabled-before': Date,
    'disabled-after': Date
  },
  data() {
    return {
      active: false,
      lastPicker: "DATE",
      watcher: undefined
    }
  },
  watch: {
    active (val) {
      if(val) {
        this.$nextTick(() => {
          this.watcher = this.$watch(() => {
            return this.$refs.datepicker.$children[1].activePicker // TODO: KORJAA PURKKA
          },
          (val) => {
            this.lastPicker = val;
          })
        })
      } else if (typeof(this.watcher) == "function") {
        this.watcher();
      }
    },
    value (newVal, oldVal) {
      if(this.lastPicker == "DATE") {
        this.active = false;
      }
    }
  },
  methods: {
    allowedDates (date) {
      if(typeof(this.disabledBefore) != "undefined" || typeof(this.disabledAfter) != "undefined") {
        return (typeof(this.disabledBefore) != "undefined" && moment(date).isSameOrAfter(this.disabledBefore,"day")) || (typeof(this.disabledAfter) != "undefined" && moment(date).isSameOrBefore(this.disabledAfter,"day"));
      }
      return true;
    }
  },
  computed: {
    date: {
      get () {
        return moment(this.value).format();
      },
      set (val) {
        this.$emit('input', moment(val).toDate());
      }
    },
    formattedDate () {
      return moment(this.value).format(this.dateFormat);
    }
  }
}
</script>
